export enum StorageKeys {
  invitedParticipants = 'INVITED_PARTICIPANTS_GRID_STORAGE',
  agentsGrid = 'AGENTS_GRID_STORAGE',
}
